// Enhanced SettingsPage with accessibility - saves to localStorage
import React, { useState, useEffect } from 'react';

const SettingsPage = () => {
  const [fontSize, setFontSize] = useState('medium');
  const [highContrast, setHighContrast] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);

  // Load saved settings
  useEffect(() => {
    const savedFontSize = localStorage.getItem('cooc-font-size') || 'medium';
    const savedHighContrast = localStorage.getItem('cooc-high-contrast') === 'true';
    const savedReducedMotion = localStorage.getItem('cooc-reduced-motion') === 'true';
    
    setFontSize(savedFontSize);
    setHighContrast(savedHighContrast);
    setReducedMotion(savedReducedMotion);
    
    applySettings(savedFontSize, savedHighContrast, savedReducedMotion);
  }, []);

  const applySettings = (font, contrast, motion) => {
    // Apply font size
    document.documentElement.style.setProperty('--base-font-size', 
      font === 'small' ? '14px' :
      font === 'large' ? '20px' :
      font === 'extra-large' ? '24px' : '16px'
    );
    
    // Apply high contrast
    if (contrast) {
      document.body.classList.add('high-contrast');
    } else {
      document.body.classList.remove('high-contrast');
    }
    
    // Apply reduced motion
    if (motion) {
      document.body.classList.add('reduced-motion');
    } else {
      document.body.classList.remove('reduced-motion');
    }
  };

  const handleFontSizeChange = (size) => {
    setFontSize(size);
    localStorage.setItem('cooc-font-size', size);
    applySettings(size, highContrast, reducedMotion);
  };

  return (
    <div className="settings-page" style={{padding: '20px', maxWidth: '800px'}}>
      <header style={{marginBottom: '32px'}}>
        <h1>Accessibility Settings</h1>
        <p>Customize COOC to work better for you</p>
      </header>

      <div className="settings-section" style={{marginBottom: '32px'}}>
        <h2>Font Size</h2>
        <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap'}}>
          {['small', 'medium', 'large', 'extra-large'].map(size => (
            <button
              key={size}
              onClick={() => handleFontSizeChange(size)}
              style={{
                padding: '12px 24px',
                backgroundColor: fontSize === size ? '#1a73e8' : '#f0f0f0',
                color: fontSize === size ? 'white' : '#333',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                textTransform: 'capitalize'
              }}
            >
              {size.replace('-', ' ')}
            </button>
          ))}
        </div>
        <p style={{fontSize: '14px', color: '#666', marginTop: '8px'}}>
          Current size: <span style={{fontWeight: 'bold'}}>{fontSize.replace('-', ' ')}</span>
        </p>
      </div>

      <div className="settings-section" style={{marginBottom: '32px'}}>
        <h2>Visual Accessibility</h2>
        <label style={{display: 'flex', alignItems: 'center', marginBottom: '12px'}}>
          <input
            type="checkbox"
            checked={highContrast}
            onChange={(e) => {
              setHighContrast(e.target.checked);
              localStorage.setItem('cooc-high-contrast', e.target.checked);
              applySettings(fontSize, e.target.checked, reducedMotion);
            }}
            style={{marginRight: '8px'}}
          />
          High Contrast Mode
        </label>
        
        <label style={{display: 'flex', alignItems: 'center'}}>
          <input
            type="checkbox"
            checked={reducedMotion}
            onChange={(e) => {
              setReducedMotion(e.target.checked);
              localStorage.setItem('cooc-reduced-motion', e.target.checked);
              applySettings(fontSize, highContrast, e.target.checked);
            }}
            style={{marginRight: '8px'}}
          />
          Reduce Motion & Animations
        </label>
      </div>

      <div style={{marginBottom: '24px', padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '8px'}}>
        <h3>Sample Text</h3>
        <p>This is how your text will look with the current settings. You can upload documents, check reminders, and use all COOC features.</p>
      </div>
    </div>
  );
};

export default SettingsPage;